import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
	static targets = [ 'header', 'stickyElement', 'staticButton' ];

    initialize() {
        this.boundToggleHeader = this.toggleHeader.bind(this);
    }

    connect() {
        addEventListener('scroll', (event) => this.boundToggleHeader(event));
    }

    disconnect() {
        addEventListener('scroll', (event) => this.boundToggleHeader(event));
    }
	
	toggleHeader() {
        if (!this.hasStickyElementTarget) {
            return;
        }
 
        if(this.hasStaticButtonTarget) {
            var headerButton = this.staticButtonTarget;
            var rect = headerButton.getBoundingClientRect();

            // Check if first button is still in screen
            if(rect.top > 0) {
                if (!this.stickyElementTarget.classList.contains('opacity-0')) {
                    this.stickyElementTarget.classList.add('opacity-0');
                    this.stickyElementTarget.classList.add('pointer-events-none');
                } 
                return;
            }
        }

        var element = this.headerTarget;
        var currentPos = document.documentElement.scrollTop || document.body.scrollTop;
        var elementHeight = this.headerTarget.clientHeight;
        var elementPostition = 0;
    
        while(element) {
            elementPostition += (element.offsetTop - element.scrollTop + element.clientTop);
            element = element.offsetParent;
        }
        if(currentPos - elementHeight > elementPostition) {
            if (!this.stickyElementTarget.classList.contains('opacity-0')) {
                this.stickyElementTarget.classList.add('opacity-0');
                this.stickyElementTarget.classList.add('pointer-events-none');
            } 
        } else {
            if (this.stickyElementTarget.classList.contains('opacity-0')) {
                this.stickyElementTarget.classList.remove('opacity-0');
                this.stickyElementTarget.classList.remove('pointer-events-none');
            }
        }
	}
}
